<template>
  <v-container class="ml-2 pa-0">
    <v-col class="ma-0 pa-0">
      <span class="query_title">{{ value.name }}</span>
      <v-row
        class="contained pa-0"
        dense
      >
        <v-col>
          <v-text-field
            v-show="selected_type != 'Select'"
            v-model="paramValue"
            label="value"
            class="ma-0 param_text pl-2"
            :type="Object.keys(DATATYPE).find(key => DATATYPE[key] == selected_type)"
            dense
            @input="handleInput"
          />
          <!-- text field for query for select -->
          <v-select
            v-show="selected_type == 'Select' && available_result.length <= 0"
            v-model="paramValue['query']"
            :items="available_query"
            item-text="name"
            item-value="id"
            label="query"
            class="ma-0 param_select pl-2"
            dense
            @change="get_available_results"
          />
          <!-- V select for type select -->
          <v-select
            v-show="available_result.length > 0 && selected_type == 'Select' && paramValue['query'] > ''"
            v-model="paramValue.selected"
            :items="available_result"
            label="value"
            class="ma-0 param_select pl-2"
            dense
            @change="handleInput"
          />
        </v-col>
        <v-col>
          <v-select
            v-model="selected_type"
            label="type"
            :items="Object.values(DATATYPE)"
            class="ma-0 param_select pr-2"
            dense
            @change="handleInput"
          />
        </v-col>
      </v-row>
    </v-col>
  </v-container>
</template>

<script>
  import ProjectService from '@/components/Dashboard/Views/Projects/services/ProjectService'
  import QueryService from '@/components/Dashboard/Views/Projects/Dashboards/services/QueryService'
  export default {
    props: {
      value: {
        type: Object,
        default: () => ({
          name: '',
          value: '',
          type: '',
        }),
      },
    },
    data () {
      return {
        DATATYPE: {
          text: 'Text',
          number: 'Number',
          date: 'Date',
          select: 'Select',
        },
        selected_type: 'Text',
        paramValue: '',

        // For type select
        show_select: false,
        available_result: [],
        available_query: [],
      }
    },
    watch: {
      selected_type () {
        if (this.selected_type === 'Select') {
          if (typeof (this.paramValue) === 'string') {
            this.paramValue = {
              query: '',
              selected: '',
            }
            this.available_result = []
          }

          // Get available query
          ProjectService.get(this, this.$route.params.project).then(r => {
            this.available_query = r.data.queries
          })

          if (this.paramValue.query > '') this.get_available_results(this.paramValue.query)
        } else {
          this.paramValue = ''
        }
      },
    },
    mounted () {
      // If there was no timeout paramValue and selected_type
      // wouldnt take value.value and value.type
      setTimeout(() => {
        this.paramValue = this.value.value
        this.selected_type = this.value.type
      }, 300)
    },
    methods: {
      handleInput () {
        /**
         * Output from the children, for the parent to retrieve with a v-model
         */
        this.$emit('input', { value: this.paramValue, type: this.selected_type, name: this.value.name })
      },
      get_available_results (queryId) {
        this.available_result = []
        QueryService.exec_query(this, { id: queryId }).then((r) => {
          r.data.data.rows.forEach((row) => {
            Object.values(row).forEach((value) => {
              this.available_result.push(value)
            })
          })
        })
      },
    },
  }
</script>

<style scoped>
.contained {
  border: solid #AAA 1px;
  border-radius: 3px;
  padding: 0;
}

.query_title {
  color: #444;
  font-weight:300;
  font-size: 0.75em;
}

.param_text {
  position: relative;
  top: 17px;
}

.param_select {
  position: relative;
  top: 10px;
}
</style>
